import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Miami needed",
      "Ideal for RSW international travelers",
      "Perfect for spring training fans heading abroad",
      "Great for Caribbean cruise passengers",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Lee County post offices",
      "Good for planned international travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Lee County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — no Southwest Florida walk-in",
      "NPIC appointment required before traveling to Miami",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function FortMyersProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Fort Myers"
      introText="Fort Myers travelers — whether heading to spring training in Canada, the Caribbean on a family cruise, or Central America for an eco-tour — have several options. Here is how they compare, and why Lee County residents choose a U.S. Department of State registered passport courier for speed and reliability without the I-75 drive to Miami."
      options={options}
      emergencyDescription="Fort Myers has no regional passport agency. Closest is Miami ~150 mi via I-75 (2.5+ hrs). Florida's single agency serves 22M+ residents. Hurricane Ian (2022) proved I-75 can become impassable for days after major storms — when you need emergency documents most, the road to Miami may not exist. Seasonal snowbird traffic doubles demand on Miami appointments Nov–April."
      disclaimerText="*Processing speed depends on eligibility and documentation. Fort Myers does not have a regional passport agency — the closest is Miami. Not all applicants qualify for Regional Agency Processing."
    />
  );
}